import type { HelpTopicPair } from "../types";

const topic: HelpTopicPair = {
  th: {
    id: "data",
    title: "ข้อมูลและการส่งออก",
    summary:
      "ส่งออกข้อมูลทั้งหมดของระบบเป็นไฟล์เดียว เพื่อสำรองข้อมูล ย้ายไปเซิร์ฟเวอร์หรือฐานข้อมูลใหม่ หรือเก็บเป็นหลักฐาน และดูวิธีนำเข้าข้อมูลกลับ",
    access:
      "ต้องมีสิทธิ์ data:export (บทบาท owner และ admin; auditor ไม่มี) การนำเข้าข้อมูลทำในคอนโซลไม่ได้ — ต้องให้ผู้ดูแลเซิร์ฟเวอร์ใช้คำสั่ง CLI (หรือผู้ที่มีสิทธิ์ data:import ซึ่งมีเฉพาะบทบาท owner)",
    shot: { file: "data-page.png", caption: "หน้า การตั้งค่า → ข้อมูลและการส่งออก" },
    sections: [
      {
        id: "whats-included",
        heading: "ไฟล์ส่งออกมีอะไรบ้าง",
        body: [
          "การส่งออกแบบเต็มรวม: บทบาท กลุ่ม ประเภทผู้ใช้ การตั้งค่าทั้งหมด (รวมแบรนด์ วิธีเข้าสู่ระบบ ฟิลด์เพิ่มเติม และระยะเวลาเก็บบันทึก) ผู้ใช้ทุกคนพร้อมโปรไฟล์ อีเมล/เบอร์โทร/รหัสผู้ใช้งาน/ชื่อผู้ใช้ บทบาท ประเภทผู้ใช้ และกลุ่มที่สังกัด รวมถึงแอปพลิเคชัน (OAuth clients) พร้อมกฎสิทธิ์เข้าถึง",
          "รหัสผู้ใช้ถูกเก็บไว้เหมือนเดิมเมื่อนำเข้า ผู้ใช้จึงยังเป็น “คนเดิม” ในทุกแอปที่เชื่อมต่อ",
          "ไฟล์เป็นรูปแบบ JSON Lines (.jsonl) — หนึ่งรายการต่อบรรทัด ออกแบบมาให้ระบบนำเข้าอ่าน ไม่ใช่ให้เปิดอ่านด้วย Excel",
        ],
        fieldsTitle: "ตัวเลือกการส่งออก",
        fields: [
          {
            name: "รวมบันทึกการใช้งาน",
            description:
              "เพิ่มบันทึกการใช้งาน (audit logs) ทั้งหมดที่ยังเก็บอยู่ลงในไฟล์ ไฟล์จะใหญ่ขึ้นมาก เลือกเมื่อต้องการเก็บประวัติไว้ด้วยตอนย้ายระบบ",
          },
          {
            name: "รวมข้อมูลรับรอง (hash รหัสผ่าน, TOTP secret — เข้ารหัส)",
            description:
              "เพิ่มค่าแฮชของรหัสผ่าน ค่าแฮชของ client secret และ secret ของการยืนยันสองขั้นตอน (เข้ารหัสไว้) ทำให้หลังย้ายระบบ ผู้ใช้เข้าสู่ระบบด้วยรหัสผ่านเดิมและแอปยืนยันตัวตนเดิมได้ทันที ถ้าไม่เลือก ผู้ใช้ต้องรีเซ็ตรหัสผ่านและตั้ง 2FA ใหม่หลังนำเข้า",
          },
        ],
        warnings: [
          "ไฟล์ที่ส่งออกมีข้อมูลส่วนบุคคลของผู้ใช้ทุกคน ไฟล์ที่ “รวมข้อมูลรับรอง” ต้องถือเป็นความลับระดับสูงสุด — เก็บในที่เข้ารหัส จำกัดคนเข้าถึง และลบเมื่อไม่ใช้แล้ว",
          "ทุกการส่งออกถูกบันทึกในบันทึกการใช้งานเป็น data.exported (scope: all หรือ all+credentials)",
        ],
      },
      {
        id: "start-export",
        heading: "เริ่มส่งออกและดาวน์โหลด",
        steps: [
          "ติ๊กตัวเลือกที่ต้องการ (“รวมบันทึกการใช้งาน” และ/หรือ “รวมข้อมูลรับรอง …”) หรือไม่ติ๊กเลยเพื่อส่งออกข้อมูลพื้นฐาน",
          "กด “เริ่มส่งออก” ระบบจะแสดงข้อความ “เริ่มส่งออกแล้ว” และเพิ่มงานใหม่ในตาราง “งานส่งออก”",
          "รอให้สถานะเปลี่ยนจาก “รอดำเนินการ” / “กำลังทำงาน” เป็น “เสร็จสิ้น” (ตารางอัปเดตเองทุก 2 วินาทีระหว่างที่มีงานค้าง)",
          "กด “ดาวน์โหลด” ท้ายแถว ไฟล์จะชื่อ auth-export-<รหัสงาน>.jsonl",
        ],
        tips: ["การส่งออกทำงานเบื้องหลัง ปิดหรือออกจากหน้านี้ได้ แล้วกลับมาดาวน์โหลดภายหลัง"],
      },
      {
        id: "jobs",
        heading: "ตาราง “งานส่งออก”",
        shot: { file: "data-jobs.png", caption: "ตารางงานส่งออกที่มีงานเสร็จสิ้นแล้ว" },
        body: ["แสดงงานส่งออกล่าสุด 50 งาน เรียงจากใหม่ไปเก่า ปุ่มโหลดใหม่ (ไอคอนลูกศรวน) ดึงสถานะล่าสุด"],
        fieldsTitle: "คอลัมน์ในตาราง",
        fields: [
          { name: "เวลา", description: "เวลาที่เริ่มงาน" },
          {
            name: "สถานะ",
            description:
              "รอดำเนินการ (สีเทา) · กำลังทำงาน (สีฟ้า) · เสร็จสิ้น (สีเขียว) · ล้มเหลว (สีแดง พร้อมข้อความสาเหตุใต้ป้าย)",
          },
          {
            name: "Scope",
            description: "all = ข้อมูลทั้งหมดไม่รวมข้อมูลรับรอง · all+credentials = รวมข้อมูลรับรอง",
          },
          { name: "เสร็จเมื่อ", description: "เวลาที่งานเสร็จ (ซ่อนไว้โดยค่าเริ่มต้น)" },
          { name: "(ปุ่ม) ดาวน์โหลด", description: "แสดงเฉพาะงานที่เสร็จสิ้นแล้ว" },
        ],
        tips: [
          "ถ้างานล้มเหลว อ่านข้อความสาเหตุใต้ป้ายสถานะ แล้วลองเริ่มใหม่ หากยังล้มเหลวให้แจ้งผู้ดูแลเซิร์ฟเวอร์",
        ],
      },
      {
        id: "import",
        heading: "การนำเข้าข้อมูล",
        body: [
          "ส่วน “นำเข้า” ในหน้านี้แสดงเพียงคำสั่งตัวอย่าง เพราะการนำเข้าเปลี่ยนข้อมูลจำนวนมากพร้อมกัน จึงให้ผู้ดูแลเซิร์ฟเวอร์ทำผ่านคำสั่ง CLI เท่านั้น ส่งข้อความนี้ให้ผู้ดูแลเซิร์ฟเวอร์ได้เลย",
          "ทดลองนำเข้า (dry run) — ระบบตรวจไฟล์และรายงานว่าจะเพิ่ม ข้าม หรือมีปัญหากี่รายการ โดยยังไม่เปลี่ยนข้อมูลจริง ควรทำทุกครั้งก่อนนำเข้าจริง",
          "โดยค่าเริ่มต้น ข้อมูลที่มีอยู่แล้ว (เช่น อีเมลซ้ำ) จะถูกข้าม ถ้าใช้ตัวเลือก --overwrite ข้อมูลในไฟล์จะเขียนทับของเดิม",
        ],
        steps: [
          "ส่งออกจากระบบต้นทาง (เลือก “รวมข้อมูลรับรอง …” ถ้าต้องการให้ผู้ใช้ใช้รหัสผ่านเดิม)",
          "ผู้ดูแลเซิร์ฟเวอร์เตรียมระบบปลายทาง (ฐานข้อมูลใหม่) แต่ยังไม่สร้างผู้ใช้ใด ๆ",
          "รันคำสั่งนำเข้าแบบ --dry-run แล้วตรวจรายงาน",
          "รันคำสั่งนำเข้าจริง",
          "ตรวจสอบ: ลองเข้าสู่ระบบด้วยบัญชีเดิม และเปรียบเทียบจำนวนผู้ใช้",
        ],
        warnings: [
          "การนำเข้าแบบเขียนทับ (--overwrite) ย้อนกลับไม่ได้ — สำรองข้อมูลระบบปลายทางก่อนเสมอ",
          "การนำเข้าจริงถูกบันทึกเป็น data.imported ในบันทึกการใช้งาน (การทดลองนำเข้าไม่ถูกบันทึก)",
        ],
      },
    ],
    related: ["audit-logs", "log-retention", "users"],
  },
  en: {
    id: "data",
    title: "Data & export",
    summary:
      "Export all platform data to one file — for backups, moving to a new server or database, or record keeping — and see how data is imported back.",
    access:
      "Needs data:export (the owner and admin roles; auditors do not have it). Imports cannot be done in the console — a server administrator runs them with the CLI (or someone with data:import, which only the owner role has).",
    shot: { file: "data-page.png", caption: "Settings → Data & export" },
    sections: [
      {
        id: "whats-included",
        heading: "What an export contains",
        body: [
          "A full export includes: roles, groups, user types, every setting (branding, sign-in methods, custom fields, log retention), every user with profile, emails / phones / user code / username, roles, user type and group memberships, and the applications (OAuth clients) with their access rules.",
          "User IDs are kept on import, so people remain “the same user” in every connected application.",
          "The file is JSON Lines (.jsonl) — one record per line — meant for the import tool, not for Excel.",
        ],
        fieldsTitle: "Export options",
        fields: [
          {
            name: "Include audit logs",
            description:
              "Adds every audit-log entry still kept. The file gets much larger; choose it to keep the history when moving.",
          },
          {
            name: "Include credentials (password hashes, TOTP secrets — encrypted)",
            description:
              "Adds password hashes, client secret hashes and (encrypted) two-step verification secrets, so after a move users keep their passwords and applications keep their secrets. Without it users must reset their passwords and set up 2FA again after import.",
          },
        ],
        warnings: [
          "Exports contain personal data of every user. A file with credentials is a top-level secret — keep it encrypted, limit who can access it, and delete it when no longer needed.",
          "Every export is recorded in the audit log as data.exported (scope: all or all+credentials).",
        ],
      },
      {
        id: "start-export",
        heading: "Start an export and download it",
        steps: [
          "Tick the options you need (“Include audit logs” and/or “Include credentials …”), or none for the basic export.",
          "Click “Start export”. “Export started” appears and a new job is added to “Export jobs”.",
          "Wait for the status to go from “Pending” / “Running” to “Done” (the table refreshes itself every 2 seconds while a job is in progress).",
          "Click “Download” at the end of the row. The file is named auth-export-<job id>.jsonl.",
        ],
        tips: ["Exports run in the background — you can leave the page and come back to download later."],
      },
      {
        id: "jobs",
        heading: "The “Export jobs” table",
        shot: { file: "data-jobs.png", caption: "Export jobs with a finished job" },
        body: [
          "The 50 most recent export jobs, newest first. The reload button (circular arrow) fetches the latest status.",
        ],
        fieldsTitle: "Columns in the table",
        fields: [
          { name: "Time", description: "When the job was started." },
          {
            name: "Status",
            description:
              "Pending (grey) · Running (blue) · Done (green) · Failed (red, with the reason under the badge).",
          },
          {
            name: "Scope",
            description: "all = everything except credentials · all+credentials = with credentials.",
          },
          { name: "Finished", description: "When the job finished (hidden by default)." },
          { name: "(button) Download", description: "Shown only for finished jobs." },
        ],
        tips: [
          "If a job failed, read the reason under the status badge and try again; if it keeps failing, contact the server administrator.",
        ],
      },
      {
        id: "import",
        heading: "Importing data",
        body: [
          "The “Import” part of this page only shows an example command: an import changes a lot of data at once, so it is done by a server administrator with the CLI. You can pass that text on to them as is.",
          "Dry run — checks the file and reports how many records would be added, skipped or rejected, without changing anything. Always do it before the real import.",
          "By default existing records (e.g. an email that already exists) are skipped; with --overwrite the file's data replaces them.",
        ],
        steps: [
          "Export from the source system (with “Include credentials …” if users should keep their passwords).",
          "The server administrator prepares the target system (new database) without creating any users yet.",
          "Run the import with --dry-run and check the report.",
          "Run the real import.",
          "Verify: sign in with an existing account and compare user counts.",
        ],
        warnings: [
          "An import with --overwrite cannot be undone — always back up the target first.",
          "Real imports are recorded as data.imported in the audit log (dry runs are not).",
        ],
      },
    ],
    related: ["audit-logs", "log-retention", "users"],
  },
};

export default topic;
